import { CgFileDocument } from "react-icons/cg";
import { IoArrowUp } from "react-icons/io5";
import { FiHeart } from "react-icons/fi";
import { BiComment } from "react-icons/bi";
import { IoShareSocialOutline } from "react-icons/io5";
import { HiOutlineBookmark } from "react-icons/hi2";
import { LuVideo } from "react-icons/lu";
import { AiOutlineEye } from "react-icons/ai";
import { IoMdLink } from "react-icons/io";
import { LuClock4 } from "react-icons/lu";
import { LuGlobe } from "react-icons/lu";
import { MdOutlinePeopleAlt } from "react-icons/md";
import { GoArrowUpRight,GoArrowUp } from "react-icons/go";
import { IoMdPhotos } from "react-icons/io";
import { BiDollar } from "react-icons/bi";
import { FaRegChartBar } from "react-icons/fa";
import { VscGraphLine } from "react-icons/vsc";
import { MdOutlineTour } from "react-icons/md";

import { MdInfoOutline } from "react-icons/md";







import { TbHandClick } from "react-icons/tb";
import { MdHelpOutline } from "react-icons/md";






export const getSvgIcons = (icon, style={color:'#f285bb'}) => {
    switch (icon) {
        case 'document':
            return <CgFileDocument style={style} />;
        case 'clock':
            return <LuClock4 style={style} />;
        case 'link':
            return <IoMdLink style={style} />;
        case 'video':
            return <LuVideo style={style} />;
        case 'heart':
            return <FiHeart style={style} />;
        case 'comment':
            return <BiComment style={style} />;
        case 'share':
            return <IoShareSocialOutline style={style} />;
        case 'eye':
            return <AiOutlineEye style={style} />;
        case 'bookmark':
            return <HiOutlineBookmark style={style} />;
        case 'globe':
            return <LuGlobe style={style} />;
        case 'people':
            return <MdOutlinePeopleAlt style={style} />;
        case 'arrow-up-right':
                return <GoArrowUpRight style={style} />;
        case 'arrow-up':
            return <GoArrowUp style={style} />;
        case 'photo':
                return <IoMdPhotos   style={style} />;
        case 'dollar':
                return <BiDollar   style={style} />;
        case 'clicks':
            return <TbHandClick   style={style} />;
        case 'bar_chart':
            return <FaRegChartBar style={style} />
        case 'line_graph':
              return <VscGraphLine style={style} />
        case 'tour':
            return <MdHelpOutline style={style} />
        case 'info':
            return <MdInfoOutline style={style} />

             
        default:
            return <CgFileDocument style={style} />;




    }

}

